import { render } from "./TabsSection.html?vue&type=template&id=3bcd9d9b&scoped=true&ts=true&external"
import script from "./TabsSection.ts?vue&type=script&lang=ts&external"
export * from "./TabsSection.ts?vue&type=script&lang=ts&external"

import "./TabsSection.scss?vue&type=style&index=0&id=3bcd9d9b&lang=scss&scoped=true&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bcd9d9b"]])

export default __exports__